import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IOnlyHotelPackage } from '@appTypes/redefined-types';
import { ICartHotelTransfer } from '@pages/hotels-page/components/hotel-details-transfer/hotel-details-transfer.logic';
import { sumCents } from '@shared/services/shown-money.service';
import { TranslatePipe } from '@ngx-translate/core';
import { StarsComponent } from '@shared/components/stars/stars.component';
import { PriceFormatPipe } from '@shared/pipes/price-format.pipe';

@Component({
  selector: 'app-cart-hotel-item-view',
  templateUrl: './cart-hotel-item-view.component.html',
  styleUrl: './cart-hotel-item-view.component.scss',
  imports: [StarsComponent, MatIcon, DatePipe, PriceFormatPipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartHotelItemViewComponent {
  readonly data = input<IOnlyHotelPackage>();
  /** R-C37 / R-HT19 (website-web#71): the transfer chosen in the hotel Details window - shown on the card and inside its price. */
  readonly transfer = input<ICartHotelTransfer | null | undefined>(null);
  /** The card's price: the hotel plus the chosen transfer, to the cent - the figure **Add to cart** showed. */
  readonly total = computed(() =>
    sumCents([Number(this.data()?.totalPrice ?? 0), Number(this.transfer()?.price ?? 0)])
  );
}
